import { useMutation } from '@hooks/reactQuery';

import { checkAcquireMultipleAsset } from '@api/assets';

import { IAcquireMultipleAssetDTO } from '@interfaces/map/dto/mapDTO';

import { ACQUIRE_ASSET } from '@constants/queryKeys';

export const useMutateCheckAcquireMultipleAsset = (onSettledCallback: (data: number) => void) => {
	const {
		mutate: handleCheckAddToCartMultipleAsset,
		isLoading: isCheckingAddToCartMultipleAsset,
	} = useMutation<IAcquireMultipleAssetDTO>({
		mutationKey: [ACQUIRE_ASSET],
		mutationFn: checkAcquireMultipleAsset,
		onSuccess: (data: number) => {
			onSettledCallback(data);
		},
	});

	return {
		handleCheckAddToCartMultipleAsset,
		isCheckingAddToCartMultipleAsset,
	};
};
